import {BgDocumentCardInterface} from "../../../components/bg-document-card/bg-document-card.ts";

export function advancedFilterScripts(): void {

    const pattern = /\{[^{}]+\}/g;
    const mobileFilterModal = document.getElementById("filter-menu");
    const mobileFilterOverlay = document.getElementById("filter-overlay");
    const mobileFilterButton = document.getElementById("filter-button");
    const mobileFilterSpan = document.getElementById("filter-close");
    const selectList = document.querySelectorAll<HTMLSelectElement>(".bg-document-list-multiple-filter-select");
    const filterGroups = document.querySelectorAll<HTMLElement>(".bg-document-list-multiple-filter-group");
    const allElementsWithTags = document.querySelectorAll<HTMLElement>('.bg-document-library-item');
    const filterApplyButton = document.getElementById("advanced-filter-apply");
    const filterApplyButtonOriginalText = filterApplyButton?.textContent ?? "";
    const filterClearButton = document.getElementById("advanced-filter-clear");
    const documentList = document.querySelector("bg-document-list");
    const resultsPerPage = parseInt(documentList?.getAttribute("page-size") || "20");
    
    const originalOptions = new Map<HTMLSelectElement, HTMLOptionElement[]>();
    
    selectList.forEach(select => {
        originalOptions.set(select, Array.from(select.options));
    });
    
    handleSelectedFilters();

    selectList.forEach((select, index) => {
        const captionContent = filterGroups[index].querySelector<HTMLElement>(".bg-document-list-multiple-filter-mobile-caption");
        const captionContentOriginalText = captionContent?.textContent ?? "";
        const selectedPrefix = select.selectedOptions[0]?.getAttribute("data-prefix") ?? "";
        if (captionContent) {
            captionContent.textContent = captionContentOriginalText.replace(pattern, selectedPrefix);
        }
        select.addEventListener('change', async () => {
            if (selectList[index].value !== "") {
                const selectedPrefix = select.selectedOptions[0]?.getAttribute("data-prefix") ?? "";
                if (captionContent) {
                    captionContent.textContent = captionContentOriginalText.replace(pattern, selectedPrefix);
                }
                
                let resetIndex = index + 1;
                while (resetIndex < selectList.length) {
                    filterGroups[resetIndex].classList.add("hidden");
                    const targetSelect = selectList[resetIndex];
                    targetSelect.value = "";
                    const originalSelectOptions = originalOptions.get(targetSelect) || [];
                    targetSelect.innerHTML = '';
                    originalSelectOptions.forEach(option => {
                        targetSelect.appendChild(option.cloneNode(true) as HTMLOptionElement);
                    });
                    resetIndex++;
                }
                
                const tagValues = updateSelectedFilters();
                const data: any = await fetchDocuments(tagValues);
                const availableFilters = data.availableFilters || [];
                
                if (index + 1 < selectList.length) {
                    const nextSelect = selectList[index + 1];
                    const originalSelectOptions = originalOptions.get(nextSelect) || [];
                    let hasAvailableOptions = false;
                    
                    nextSelect.innerHTML = '';
                    
                    originalSelectOptions.forEach(option => {
                        const optionClone = option.cloneNode(true) as HTMLOptionElement;
                        if (availableFilters.includes(optionClone.value) || optionClone.value === "") {
                            nextSelect.appendChild(optionClone);
                            if (optionClone.value !== "") {
                                hasAvailableOptions = true;
                            }
                        }
                    });
                    
                    if (hasAvailableOptions) {
                        filterGroups[index + 1].classList.remove("hidden");
                    }
                }
            } else {
                let hiddenIndex = index + 1;
                while (hiddenIndex < selectList.length) {
                    filterGroups[hiddenIndex].classList.add("hidden");
                    const targetSelect = selectList[hiddenIndex];
                    targetSelect.value = "";
                    const originalSelectOptions = originalOptions.get(targetSelect) || [];
                    targetSelect.innerHTML = '';
                    originalSelectOptions.forEach(option => {
                        targetSelect.appendChild(option.cloneNode(true) as HTMLOptionElement);
                    });
                    hiddenIndex++;
                }
                if (captionContent) {
                    captionContent.textContent = captionContentOriginalText.replace(pattern, '');
                }
            }
            
            if (index === 0) {
                filterGroups[index].classList.remove("hidden");
            }
            
            updateResultsCount();
        });
    });

    filterApplyButton?.addEventListener('click', () => {
        let filterApplyButtonHref = "?filter=";
        const selectedTagList: string[] = [];
        selectList.forEach(tagGroup => {
            if (tagGroup.value !== "") {
                selectedTagList.push(tagGroup.value);
            }
        });
        filterApplyButtonHref += selectedTagList.join(",");
        if (selectedTagList.length > 0) {
            window.location.href = window.location.pathname + filterApplyButtonHref.toLowerCase();
        } else {
            window.location.href = window.location.pathname;
        }
    });

    filterClearButton?.addEventListener('click', () => {
        filterGroups.forEach((tagGroup, index) => {
            if (index !== 0) {
                if (!tagGroup.classList.contains("hidden")) {
                    tagGroup.classList.add("hidden");
                }
            }
        });
        selectList.forEach(selectItem => {
            selectItem.value = "";
            const originalSelectOptions = originalOptions.get(selectItem) || [];
            selectItem.innerHTML = '';
            originalSelectOptions.forEach(option => {
                selectItem.appendChild(option.cloneNode(true) as HTMLOptionElement);
            });
        });
        if (filterApplyButton) {
            filterApplyButton.textContent = filterApplyButtonOriginalText.replace(pattern, "0");
        }
    });

    if (allElementsWithTags.length > 0) {
        allElementsWithTags.forEach(element => {
            element.classList.remove("hidden");
        });
    }


    if (mobileFilterButton) {
        mobileFilterButton.addEventListener("click", async () => {

            updateResultsCount();
            if (mobileFilterModal) {
                mobileFilterModal.style.display = "flex";
                if (filterApplyButton) {
                    filterApplyButton.textContent = filterApplyButtonOriginalText.replace(pattern, String(allElementsWithTags.length));
                }
            }
            if (mobileFilterOverlay) {
                mobileFilterOverlay.style.display = "block";
            }
        });
    }

    mobileFilterOverlay?.addEventListener("click", function () {
        if (mobileFilterModal) {
            mobileFilterModal.style.display = "none";
        }
        if (mobileFilterOverlay) {
            mobileFilterOverlay.style.display = "none";
        }
    })

    if (mobileFilterSpan) {
        mobileFilterSpan.addEventListener("click", function () {
            if (mobileFilterModal) {
                mobileFilterModal.style.display = "none";
            }
            if (mobileFilterOverlay) {
                mobileFilterOverlay.style.display = "none";
            }
        });

        window.addEventListener("click", function (event) {
            if (event.target === mobileFilterModal) {
                if (mobileFilterModal) {
                    mobileFilterModal.style.display = "none";
                }
                if (mobileFilterOverlay) {
                    mobileFilterOverlay.style.display = "none";
                }
            }
        });
    }

    function handleSelectedFilters() {
        const filterMenu = document.getElementById("filter-menu");
        if (filterMenu) {
            const dataTagsString = filterMenu.getAttribute("data-tags");
            if (dataTagsString) {
                const filteredTags = dataTagsString.split(",");
                const selectElements = document.querySelectorAll<HTMLSelectElement>(".bg-document-list-multiple-filter-select");
                selectElements.forEach((selectElement, index) => {
                    if (selectElement) {
                        const optionList = Array.from(selectElement.options);
                        optionList.forEach(option => {
                            if (filteredTags[index] === option.value) {
                                option.selected = true;
                                filterGroups[index].classList.remove("hidden");
                                if (index + 1 < selectElements.length)
                                    filterGroups[index + 1].classList.remove("hidden");
                            }
                        });
                    }
                });
            }
        }
    }

    function updateResultsCount() {
        const selectedFilterList: string[] = [];
        selectList.forEach(select => {
            if (select.value !== "") {
                selectedFilterList.push(select.value.toLowerCase());
            }
        });
        const allElementsWithTags = document.querySelectorAll<HTMLElement>('.bg-document-library-item');
        const matchingElements = Array.from(allElementsWithTags).filter(element => {
            try {
                const tags = (element as HTMLElement).dataset.tags;
                if (!tags) return false;
                const elementTags = JSON.parse(tags);
                element.classList.add("hidden");
                if (Array.isArray(elementTags)) {
                    return selectedFilterList.some(tag => elementTags.includes(tag));
                }
            } catch (e) {
                console.error("Error parsing data-tags for element:", element, e);
            }
            return false;
        });
    }

    function updateSelectedFilters() {
        const selectedTagList: string[] = [];
        selectList.forEach(tagGroup => {
            if (tagGroup.value !== "") {
                selectedTagList.push(tagGroup.value);
            }
        });
        const filterMenu = document.getElementById("filter-menu");
        if (filterMenu) {
            filterMenu.setAttribute("data-tags", selectedTagList.join(",").toLowerCase());
        }
        return selectedTagList
    }

    async function fetchDocuments(tagValues) {
        const filterApplyButton = document.getElementById("advanced-filter-apply");
        const filterApplyButtonOriginalText = filterApplyButton?.textContent;
        const pattern = /\d+/g;
        const siteIdentifier = document.querySelector("bg-document-list")?.getAttribute('site-identifier') || "";
        let response: any = {};
        const url = '/search/documents/';
        const body = {
            "tagName": "tags",
            "tagValues": tagValues || [],
            "siteIdentifier": `${siteIdentifier}`,
            "doctypeFilter": [
                "ecDocument"
            ],
            "OrderByField": "date",
            "SortDirection": "asc",
            "booleanOperation": "and",
            "maxResultsToRetrieve": 1000,
            "pageResults": true,
            "pageIndexNumber": 0,
            "skip": 0,
            "resultsPerPage": resultsPerPage
        };

        response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                console.log('Success', data);
                if (filterApplyButton) {
                    filterApplyButton.textContent = filterApplyButtonOriginalText?.replace(pattern, String(data.totalHits)) || "";
                }
                return data;
            })
            .catch(error => {
                console.error('Error: ', error);
                return {};
            });

        return response;
    }

}